export default "/images/971b7d540257bc72631c091ec2b2af2d.avif";